import { DocsBlockBuilder } from "../../../../../../tools/docs-block-builder/SDKDocsBlockBuilder";
import { DocsBlockCategory } from "../../../../../enums/SDKDocsBlockCategory";
import { DocsBlockMultiRichTextPropertyStyle } from "../../../../../enums/SDKDocsBlockMultiRichTextPropertyStyle";
const b = new DocsBlockBuilder();
/**
 * 1. Block metadata
 */
const id = "io.supernova.block.unordered-list";
const name = "Bulleted list";
const icon = "https://cdn-assets.supernova.io/blocks/icons/list-unordered.svg";
const descriptionShort = "A list with bullet points";
const searchKeywords = ["ul", "bullet points"];
const descriptionFull = "A list of items displayed with bullet points without a specific sequence.";
const docsUrl = "https://learn.supernova.io/latest/documentation/types-of-blocks/text/list-UC5iPZLK";
/**
 * 2. Block properties
 */
const properties = {
    text: b.multiRichTextProperty({
        id: "text",
        name: "Text",
        options: {
            multiRichTextStyle: DocsBlockMultiRichTextPropertyStyle.ul,
        },
    }),
};
/**
 * 3. Block variants
 */
const defaultVariant = b.defaultVariantUsingDefaultLayout({
    properties: [properties.text],
});
/**
 * 4. Block item
 */
const blockItem = b.singleVariantItem({
    properties: [properties.text],
    variant: defaultVariant,
});
/**
 * 5. Block definition
 */
const block = b.singleItemBlock({
    id,
    name,
    icon,
    category: DocsBlockCategory.text,
    description: descriptionShort,
    item: blockItem,
    searchKeywords,
    onboarding: b.onboarding({
        helpText: descriptionFull,
        documentationLink: docsUrl,
    }),
});
/** 6. Block export */
export { block as UnorderedList };
